module.exports = __webpack_public_path__ + "04f6208bc8a70613e96738f23ce1fe65.MP3";